// @flow
import React, { useEffect, useRef } from 'react';
import dataFormat from 'date-fns/format';
import ko from 'date-fns/locale/ko';
import Button from '../../common/Button';
import './CheckoutSuccessTemplate.scss';
import { numberWithCommas } from '../../../lib/common';

type Props = {
  order: any,
  history: any,
  tosspayments: any,
  logged: boolean,
  token: ?string,
};

const CheckoutSuccessTemplate = (props: Props) => {
  const canvasRef = useRef(null);

  // 토스페이먼츠 카드영수증 다운로드
  const goTossPayReceipt = () => {
    console.log(props.tosspayments);
    if (props.tosspayments && props.tosspayments.receipt && props.tosspayments.receipt.url) {
      window.open(props.tosspayments.receipt.url, 'goTossPayReceipt', 'width=500, height=700;');
    }
  };

  // 문서 다운로드 함수
  const downloadDocument = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // 견적서 페이지로 이동
  const goOffer = (orderId, token) => {
    if (token) {
      props.history.push(`/orders/${orderId}/offer?token=${token}`);
    } else {
      props.history.push(`/orders/${orderId}/offer`);
    }
  };

  // 거래명세서 페이지로 이동
  const goInvoice = (orderId, token) => {
    if (token) {
      props.history.push(`/orders/${orderId}/invoice?token=${token}`);
    } else {
      props.history.push(`/orders/${orderId}/invoice`);
    }
  };

  useEffect(() => {
    // Canvas confetti 이팩트 초기화
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let W = window.innerWidth;
    let H = window.innerHeight;
    canvas.width = W;
    canvas.height = H;

    const mp = 150; // max particles
    const particles = [];
    let angle = 0;
    let animationComplete = false;
    let animationHandler;

    const particleColors = [
      '#ff6b6b',
      '#4ecdc4',
      '#45b7d1',
      '#f9ca24',
      '#6c5ce7',
      '#a29bfe',
      '#fd79a8',
      '#00b894',
      '#e17055',
    ];

    function ConfettiParticle() {
      this.x = Math.random() * W;
      this.y = Math.random() * H - H;
      this.r = Math.random() * 6 + 4; // radius 4-10
      this.d = Math.random() * mp + 10; // density
      this.color = particleColors[Math.floor(Math.random() * particleColors.length)];
      this.tilt = Math.floor(Math.random() * 10) - 10;
      this.tiltAngleIncremental = Math.random() * 0.07 + 0.05;
      this.tiltAngle = 0;

      this.draw = () => {
        ctx.beginPath();
        ctx.lineWidth = this.r / 2;
        ctx.strokeStyle = this.color;
        ctx.moveTo(this.x + this.tilt + this.r / 4, this.y);
        ctx.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4);
        ctx.stroke();
      };
    }

    function stopConfetti() {
      animationComplete = true;
      if (animationHandler) {
        cancelAnimationFrame(animationHandler);
      }
      ctx.clearRect(0, 0, W, H);
    }

    function update() {
      let remainingFlakes = 0;
      angle += 0.01;

      for (let i = 0; i < mp; i += 1) {
        const particle = particles[i];
        if (animationComplete) return;

        particle.tiltAngle += particle.tiltAngleIncremental;
        particle.y += (Math.cos(angle + particle.d) + 3 + particle.r / 2) / 3;
        particle.x += Math.sin(angle);
        particle.tilt = Math.sin(particle.tiltAngle - i / 3) * 15;

        if (particle.y <= H) {
          remainingFlakes += 1;
        }

        // 화면 밖으로 나간 파티클 재배치 (더 관대한 조건)
        if (particle.x > W + 50 || particle.x < -50 || particle.y > H + 50) {
          // 재배치 빈도를 줄여서 더 자연스럽게
          if (i % 5 === 0 && Math.random() > 0.3) {
            particle.x = Math.random() * W;
            particle.y = -10;
          } else if (Math.sin(angle) > 0 && Math.random() > 0.5) {
            particle.x = -20;
            particle.y = Math.random() * H;
          } else if (Math.random() > 0.5) {
            particle.x = W + 20;
            particle.y = Math.random() * H;
          }
        }
      }

      // 자동 종료 조건 제거 - 타이머로만 제어
      // if (remainingFlakes === 0) {
      //   stopConfetti();
      // }
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      for (let i = 0; i < mp; i += 1) {
        particles[i].draw();
      }
      update();
    }

    function startConfetti() {
      function animloop() {
        if (animationComplete) return null;
        animationHandler = requestAnimationFrame(animloop);
        return draw();
      }
      animloop();
    }

    function initializeConfetti() {
      particles.length = 0;
      animationComplete = false;
      for (let i = 0; i < mp; i += 1) {
        particles.push(new ConfettiParticle());
      }
      startConfetti();
    }

    // 윈도우 리사이즈 핸들러
    const handleResize = () => {
      W = window.innerWidth;
      H = window.innerHeight;
      canvas.width = W;
      canvas.height = H;
    };

    window.addEventListener('resize', handleResize);

    // 0.5초 후 confetti 시작
    const timer = setTimeout(() => {
      initializeConfetti();
    }, 500);

    // 10초 후 자동 종료
    const stopTimer = setTimeout(() => {
      stopConfetti();
    }, 10000);

    // 정리 함수
    function cleanup() {
      clearTimeout(timer);
      clearTimeout(stopTimer);
      window.removeEventListener('resize', handleResize);
      if (animationHandler) {
        cancelAnimationFrame(animationHandler);
      }
    }
  }, []);

  return (
    <div className="CheckoutSuccessTemplate">
      {/* Canvas 기반 Confetti */}
      <canvas
        ref={canvasRef}
        className="confetti-canvas"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'none',
          zIndex: 1000,
        }}
      />

      <div className="checkout-success-container">
        {/* 성공 헤더 섹션 */}
        <div className="success-header">
          <h1 className="success-title">
            주문이 완료되었습니다!
            <span className="success-icon-inline" role="img" aria-label="축하">
              🎉
            </span>
          </h1>
          <p className="success-subtitle">
            주문해 주셔서 감사합니다.
            <br />곧 처리해드리겠습니다.
          </p>
        </div>

        {/* 주문 정보 카드 */}
        <div className="order-info-card">
          <div className="card-header">
            <span className="card-icon" role="img" aria-label="주문 정보">
              📋
            </span>
            <h2 className="card-title">주문 정보</h2>
          </div>
          <div className="card-content">
            <div className="info-row">
              <span className="info-label">주문 번호</span>
              <div className="info-value">
                <span className="order-id">{props.order.id}</span>
                <button
                  className="copy-button"
                  onClick={() => {
                    navigator.clipboard.writeText(props.order.id);
                  }}
                  aria-label="주문번호 복사"
                >
                  <span role="img" aria-label="복사">
                    📋
                  </span>
                </button>
              </div>
            </div>
            <div className="info-row">
              <span className="info-label">주문 총액</span>
              <span className="info-value amount">
                {numberWithCommas(props.order.total.amount.raw)}원
              </span>
            </div>
            <div className="info-row">
              <span className="info-label">주문 일시</span>
              <span className="info-value">
                {dataFormat(props.order.created_at, 'YYYY년 M월 D일 HH시 mm분')}
              </span>
            </div>
          </div>
        </div>

        {/* 다음 단계 안내 */}
        {/* <div className="next-steps-card">
        <div className="card-header">
          <span className="card-icon" role="img" aria-label="다음 단계">🚀</span>
          <h2 className="card-title">다음 단계</h2>
        </div>
        <div className="card-content">
          <div className="step-item">
            <span className="step-icon" role="img" aria-label="이메일">📧</span>
            <div className="step-content">
              <h3>주문 확인 이메일</h3>
              <p>주문 확인 이메일을 발송해드렸습니다.</p>
            </div>
          </div>
          <div className="step-item">
            <span className="step-icon" role="img" aria-label="배송">🚚</span>
            <div className="step-content">
              <h3>배송 준비</h3>
              <p>1-2일 내에 배송 준비를 시작합니다.</p>
            </div>
          </div>
          <div className="step-item">
            <span className="step-icon" role="img" aria-label="알림">🔔</span>
            <div className="step-content">
              <h3>배송 알림</h3>
              <p>배송 시작 시 SMS로 알림을 보내드립니다.</p>
            </div>
          </div>
        </div>
      </div> */}

        {/* 문서 다운로드 섹션 */}
        <div className="document-download-card">
          <div className="card-header">
            <span className="card-icon" role="img" aria-label="문서 다운로드">
              📁
            </span>
            <h2 className="card-title">문서 다운로드</h2>
          </div>
          <div className="card-content">
            <div className="document-grid">
              <button
                className="document-button business-cert"
                onClick={() =>
                  downloadDocument(
                    'https://images.cacheby.com/documents/데이터씨_사업자등록증.pdf',
                    '데이터씨_사업자등록증.pdf',
                  )
                }
              >
                <div className="document-icon">
                  <span role="img" aria-label="사업자등록증">
                    🏢
                  </span>
                </div>
                <div className="document-content">
                  <h3>사업자등록증</h3>
                  <p>Business Registration</p>
                </div>
              </button>

              <button
                className="document-button bank-copy"
                onClick={() =>
                  downloadDocument(
                    'https://images.cacheby.com/documents/데이터씨_통장사본.pdf',
                    '데이터씨_통장사본.pdf',
                  )
                }
              >
                <div className="document-icon">
                  <span role="img" aria-label="통장사본">
                    🏦
                  </span>
                </div>
                <div className="document-content">
                  <h3>통장사본</h3>
                  <p>Bank Account Copy</p>
                </div>
              </button>

              <button className="document-button quote" onClick={() => goOffer(props.order.id, props.token)}>
                <div className="document-icon">
                  <span role="img" aria-label="견적서">
                    📋
                  </span>
                </div>
                <div className="document-content">
                  <h3>견적서</h3>
                  <p>Quotation</p>
                </div>
              </button>

              <button className="document-button invoice" onClick={() => goInvoice(props.order.id, props.token)}>
                <div className="document-icon">
                  <span role="img" aria-label="거래명세서">
                    📊
                  </span>
                </div>
                <div className="document-content">
                  <h3>거래명세서</h3>
                  <p>Transaction Statement</p>
                </div>
              </button>

              {props.tosspayments && props.tosspayments.receipt && props.tosspayments.receipt.url && (
                <button className="document-button receipt" onClick={goTossPayReceipt}>
                  <div className="document-icon">
                    <span role="img" aria-label="카드영수증">
                      💳
                    </span>
                  </div>
                  <div className="document-content">
                    <h3>카드영수증</h3>
                    <p>Card Receipt</p>
                  </div>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* 액션 버튼들 */}
        <div className="success-actions">
          <Button
            className="primary-button"
            to={
              props.logged
                ? `/orders/${props.order.id}`
                : `/orders/${props.order.id}?token=${props.token}`
            }
          >
            <span className="button-icon" role="img" aria-label="상세보기">
              📄
            </span>
            주문 상세보기
          </Button>
          <Button className="secondary-button" to="/">
            <span className="button-icon" role="img" aria-label="홈으로">
              🏠
            </span>
            쇼핑 계속하기
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessTemplate;



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutSuccessTemplate/CheckoutSuccessTemplate.js